import utils from '../../utils'

const BinaryReader = function(data, offset, count) {
    this.data = data;
    this.position = 0;
    if (!data) {
        this.array = [];
    }
    else if (typeof data === 'string') {
        this.array = data;
    }
    else if (data instanceof ArrayBuffer) {
        this.array = new Uint8Array(data);
    }
    else if (utils.isArray(data) || (typeof data.length !== 'undefined')) {
        this.array = data;
    }
    else {
        this.array = [];
    }
    this.offset = typeof offset === 'undefined' ?  0 : offset;
    this.length = typeof count  === 'undefined' ? (this.array.length - this.offset) : count;
};

const pt = BinaryReader.prototype;

pt.readInt8 = function() {
    if (this.position >= this.length) {
        throw new Error('End of the stream');
    }
    let value = this.array[this.offset + (this.position++)];
    return (value & 0xFF);
};

pt.readInt16 = function() {
    let value = this.readInt8();
    value <<= 8;
    value |= this.readInt8();
    return value;
};

pt.readInt32 = function() {
    let value = this.readInt16();
    value <<= 16;
    value |= this.readInt16();
    return value;
};

pt.readUInt32 = function() {
    return (this.readInt32() >>> 0);
};

pt.readUInt64 = function() {
    const high = this.readUInt32().toString(16);
    const low = this.readUInt32().toString(16);
    let s = high;
    for(let i = low.length; i < 8; i++) {
        s += '0';
    }
    s += low;
    return parseInt(s, 16);
};

pt.readString = function() {
    const len = this.readInt32();
    if (len == 0)
        return "";
    let bytes = [];
    bytes.length = len;
    this.readBuffer(bytes, 0, len);
    let s = utils.utf8ByteArrayToString(bytes);
    return s;
};

pt.readBuffer = function(buf, offset, count) {
    if (typeof offset === 'undefined') offset = 0;
    if (typeof count === 'undefined') count = buf.length - offset;
    for (let i = offset, end = offset + count; i < end; i++) {
        buf[i] = this.readInt8();
    }
};

export default BinaryReader;
